import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { MenuDTO } from '../models/menu-dto';

@Injectable({
  providedIn: 'root'
})
export class SharedService {


  private pathAPI = environment.urlAPI;
  private controller = "Shared/";

  constructor(private http: HttpClient) { }

  public getMenu(): Observable<MenuDTO> {
    return this.http.get<MenuDTO>(this.pathAPI + this.controller + 'GetMenu');
  }

  public GetRoles(): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'GetRoles');
  }

  public GetCountries(): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'GetCountries');
  }

  public GetDelegations(): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'GetDelegations');
  }


  public GetDistributors(): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'GetDistributors');
  }

  public GetMonths(): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'GetMonths');
  }

}
